<template>
    <el-dialog
        title="Send Mail"
        closeable
        :visible.sync="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :modal-append-to-body="true"
        :append-to-body="true"
        @close="close"
        width="50%"
    >
        <el-alert v-if="notes && notes.length" type="info" :closable="false" title="What happens when you send" style="margin-bottom:16px">
            <ul style="margin:4px 0 0;padding-left:18px">
                <li v-for="(line, i) in notes" :key="i">{{ line }}</li>
            </ul>
        </el-alert>
        <el-form size="medium" label-width="120px">
            <el-form-item label="Subject">
                <el-input v-model="options.subject" class="w500" placeholder="Subject" clearable/>
            </el-form-item>
            <el-form-item label="Mail Template">
                <el-select v-model="options.mail_template_id" placeholder="Select template">
                    <el-option
                        v-for="item in templateList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Mail From">
                <el-select v-model="options.mail_account_id" placeholder="Select mail">
                    <el-option
                        v-for="item in configList"
                        :key="item.id"
                        :label="item.from_name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="CC">
                <el-input v-model="options.cc" class="w500" placeholder="CC" clearable/>
            </el-form-item>
            <el-form-item label="BCC">
                <el-input v-model="options.bcc" class="w500" placeholder="BCC" clearable/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSend">Send</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import ApiService from "../utils/ApiService";

export default {
    name: "ModalSendMail",
    // Lines describing what this send will do (see formHelpers.rtb7Effects); shown above the form.
    props: {notes: {type: Array, default: () => []}},
    data() {
        return {
            visible: false,
            templateList: [],
            configList: [],
            options: {
                mail_template_id: null,
                mail_account_id: null,
                subject: null,
                cc: null,
                bcc: null,
            },
            captcha: '',
            randomCode:''
        }
    },
    methods: {
        open() {
            this.visible = true;
            this.randomCode = Math.floor(Math.random() * 10000).toString();
        },
        close() {
            this.visible = false;
        },
        fetchTemplateList() {
            ApiService.get('/buildium/mail-templates').then(response => {
                this.templateList = response.data.items;
            }).catch(reason => {
                this.$message.error(reason.message);
            });
        },
        fetchConfigList() {
            ApiService.get('/buildium/mail-configs').then(response => {
                this.configList = response.data.items;
            }).catch(reason => {
                this.$message.error(reason.message);
            });
        },
        onSend() {
            const options = this.options;
            if (!options.subject) {
                this.$message.error('Subject is required');
                return;
            }

            if (!options.mail_template_id) {
                this.$message.error('Mail template is required');
                return;
            }

            if (!options.mail_account_id) {
                this.$message.error('Mail account is required');
                return;
            }

            // if (this.captcha !== this.randomCode){
            //     this.$message.error('Captcha is incorrect');
            //     return;
            // }

            this.$emit('send', this.options);
            this.close();
        }
    },
    mounted() {
        this.fetchTemplateList();
        this.fetchConfigList();
    }
}
</script>

<style scoped>

</style>